export const PATH_BREADCRUMB = {
    alloggio_residenza: {
        it: '/it/residenze-alloggi',
        en: '/en/housing'
    },
    avvisi: {
        it: '/it/newsroom/tutti-gli-avvisi',
        en: '/en/newsroom/all-notices'
    },
    bando: {
        it: '/it/tutti-i-bandi',
        en: '/en/all-calls'
    },
    convenzione: {
        it: '/it/convenzioni-commerciali',
        en: '/en/discounts'
    },
    corso_di_studi: {
        it: '/it/corsi',
        en: '/en/all-courses'
    },
    docenti: {
        it: '/it/docenti-lumsa',
        en: '/en/faculty-lumsa'
    },
    eventi: {
        it: '/it/newsroom/tutti-gli-eventi',
        en: '/en/newsroom/all-events'
    },
    faq: {
        it: '/it/tutte-le-faq-procedure',
        en: '/en/all-faqs-and-procedures'
    },
    notizie: {
        it: '/it/newsroom/tutte-le-notizie',
        en: '/en/newsroom/all-news'
    },
    persona: {
        it: '/it/tutte-le-persone',
        en: '/en/people'
    },
    procedura_servizio: {
        it: '/it/tutte-le-faq-procedure',
        en: '/en/all-faqs-and-procedures'
    }
};